import React, { Component } from "react";

class FmsNotes extends Component {
  
  constructor(props) {
		super(props);
		this.state={
			notesArray: [],
			notesCorrectNum: 0,
		}
	}
 
	componentDidMount(){
		
		let currentNum = 0;
		if ( window['fmsNotes'] )
			{
				currentNum = window['fmsNotes'].length;
				currentNum = currentNum - 1;
				this.setState({
					notesArray: window['fmsNotes'],
					notesCorrectNum: currentNum,
				});
			}
		
	}
	
	render() {
		return (
			<div>	
				{ this.state.notesArray.map((item, i) =>
					<div key={i}>
						<div className="fms_note_img" style={{backgroundImage: "url('" + item.file + "')"}} onClick={(e) => this.props.openZoomNote(i)}></div>
						<div className="fms_note_text" >{item.note}</div>
						{i < this.state.notesCorrectNum &&
							<div className="bottom_line_notes" ></div>
						}
					</div>
				)}
			</div>
	)}
}
export default FmsNotes;
